import { fetchWithAuth } from './fetchWithAuth';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

// 조합원 목록 조회 (페이징)
export const fetchMemberList = async (emp_no, name, div_sub, department, job_code, section, withdraw_yn, join_dt, join_dt_cond, has_position, page = 1, pageSize = 20) => {
  const params = new URLSearchParams();
  if (emp_no)       params.append('emp_no',       emp_no);
  if (name)         params.append('name',         name);
  if (div_sub)      params.append('div_sub',      div_sub);
  if (department)   params.append('department',   department);
  if (job_code)     params.append('job_code',     job_code);
  if (section)      params.append('section',      section);
  if (withdraw_yn)  params.append('withdraw_yn',  withdraw_yn);
  if (join_dt)       params.append('join_dt',       join_dt);
  if (join_dt_cond)  params.append('join_dt_cond',  join_dt_cond);
  if (has_position)  params.append('has_position',  has_position);
  params.append('page', page);
  params.append('pageSize', pageSize);

  return fetchWithAuth(`/members?${params}`);
};

// 조합원 상세 조회
export const fetchMemberDetail = async (emp_no) => {
  return fetchWithAuth(`/members/${emp_no}`);
};

// 조합원 등록
export const createMember = async (form) => {
  return fetchWithAuth(`/members`, { method: 'POST', body: JSON.stringify(form) });
};

// 조합원 수정
export const updateMember = async (emp_no, form) => {
  return fetchWithAuth(`/members/${emp_no}`, { method: 'PUT', body: JSON.stringify(form) });
};

// 조합원 삭제
export const deleteMember = async (emp_no) => {
  return fetchWithAuth(`/members/${emp_no}`, { method: 'DELETE' });
};

// 엑셀 임포트 — FormData 사용, fetchWithAuth가 자동으로 Content-Type 생략 처리
export const uploadMemberExcel = async (file, mode = 'add') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mode', mode);

  return fetchWithAuth(`/members/upload-excel`, {
    method: 'POST',
    body  : formData,
  });
};

// 간병사 검색
export const searchCarer = async (name) => {
  return fetchWithAuth(`/members/search-carer?name=${encodeURIComponent(name)}`);
};

// 소속 풀다운용
export const fetchDivisionSubList = async () => {
  return fetchWithAuth(`/members/division-sub`);
};

// 직종 풀다운용
export const fetchJobCodeList = async () => {
  return fetchWithAuth(`/members/job-code`);
};

// 소속 풀다운용
export const fetchDivisionSubNameList = async () => {
  return fetchWithAuth(`/members/division-sub-names`);
};

// 조합원 삭제 원복
export const restoreMember = async (emp_no) => {
  return fetchWithAuth(`/members/${emp_no}/restore`, { method: 'POST' });
};

export const fetchDivisionSubListFromTable = async () => {
  return fetchWithAuth(`/members/division-sub-table`);
};

// 엑셀 다운로드 - blob 처리 (fetchWithAuth는 json 전용이라 별도 처리)
export const downloadMemberExcel = async (params) => {
  const query = new URLSearchParams(params).toString();
  const res = await fetch(`${BASE_URL}/members/excel?${query}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  if (!res.ok) throw new Error('엑셀 다운로드 실패');

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `조합원명단_${new Date().toISOString().slice(0,10)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// 선거인명부용 전체 데이터 조회
export const fetchVoterList = async (params) => {
  const query = new URLSearchParams(params).toString();
  return fetchWithAuth(`/members/voter-list?${query}`);
};

// 지구 추천검색
export const searchMemberSection = async (division_sub_name, department, job_name) => {
  const params = new URLSearchParams();
  if (division_sub_name) params.append('division_sub_name', division_sub_name);
  params.append('department', department);
  params.append('job_name', job_name);
  return fetchWithAuth(`/members/search-section?${params}`);
};

// 엑셀 업로드 진행상황 조회 (폴링용)
export const fetchUploadJobStatus = async (jobId) => {
  return fetchWithAuth(`/members/upload-excel/${jobId}`);
};

// 소속 등록
export const createDivisionSub = async (division_sub_name) => {
  return fetchWithAuth(`/members/division-sub`, { method: 'POST', body: JSON.stringify({ division_sub_name }) });
};

// 소속 수정
export const updateDivisionSub = async (division_sub_code, division_sub_name) => {
  return fetchWithAuth(`/members/division-sub/${division_sub_code}`, { method: 'PUT', body: JSON.stringify({ division_sub_name }) });
};

// 소속 삭제
export const deleteDivisionSub = async (division_sub_code) => {
  return fetchWithAuth(`/members/division-sub/${division_sub_code}`, { method: 'DELETE' });
};

// 정원 기준자료 목록 조회
export const fetchQuotaList = async () => {
  return fetchWithAuth(`/members/quota`);
};

// 정원 등록/수정
export const saveQuota = async (data) => {
  return fetchWithAuth(`/members/quota`, { method: 'POST', body: JSON.stringify(data) });
};

// 정원 삭제
export const deleteQuota = async (division_sub_name, job_name) => {
  return fetchWithAuth(`/members/quota/delete`, { method: 'POST', body: JSON.stringify({ division_sub_name, job_name }) });
};

// 조합원 현황 리포트 조회
export const fetchStatusReport = async () => {
  return fetchWithAuth(`/members/status-report`);
};

// 비밀번호 초기화 (연락처 뒷자리 4자리) — 화면에 표시된 연락처 값을 그대로 전달
export const resetMemberPassword = async (emp_no, phone) => {
  return fetchWithAuth(`/members/${emp_no}/reset-password`, {
    method: 'POST',
    body: JSON.stringify({ phone }),
  });
};